import type { RoleCategory } from '@/blocks/domain/types/BlockContent/RolesResponsibilitiesContent';
import { CanvasEyeButton } from '@/document-render/presentation/editing/quote/CanvasEyeButton';
import type { LiveDocumentEditingConfig } from '@/document-render/presentation/editing/quote/LiveDocumentEditingConfig';

export function RoleQuoteRow({
  rowId,
  text,
  hidden,
  onToggle
}: {
  rowId: string;
  text: string;
  hidden: boolean;
  onToggle?: (rowId: string, nextVisible: boolean) => void;
}) {
  return (
    <div style={{ opacity: hidden ? 0.5 : 1 }}>
      <span>{text}</span>
      {onToggle ? (
        <CanvasEyeButton label={`${hidden ? 'Show' : 'Hide'} ${text}`} pressed={!hidden} onToggle={() => onToggle(rowId, hidden)} />
      ) : null}
    </div>
  );
}

export function RolesQuoteGroup({ categories, editing }: { categories: RoleCategory[]; editing: LiveDocumentEditingConfig }) {
  return (
    <div>
      {categories.map((category) => {
        const visible = category.rows.some((row) => row.hidden !== true);
        return (
          <div key={category.id}>
            {editing.onToggleRoleGroupHidden ? (
              <CanvasEyeButton
                label={`${visible ? 'Hide' : 'Show'} ${category.name}`}
                pressed={visible}
                onToggle={() =>
                  editing.onToggleRoleGroupHidden?.(
                    category.rows.map((row) => row.id),
                    !visible
                  )
                }
              />
            ) : null}
            {category.rows.map((row) => (
              <RoleQuoteRow
                key={row.id}
                rowId={row.id}
                text={row.text}
                hidden={row.hidden === true}
                onToggle={editing.onToggleRoleRowHidden}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
}
